export default function initUserMenu() {

    const trigger = "[data-user-nav-menu]",
        openDuration = 250,

        $userNav = $(".user-nav"),
        openingUserNavClass = "user-nav--opening",
        openUserNavClass = "user-nav--open",

        userInfoClass = "user-info",
        activeUserInfoClass = "user-info--active";

    $(document).mouseup(function (e) {
        const container = $(".user-info, .user-nav");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(userInfoClass).removeClass(activeUserInfoClass);
            $userNav.removeClass(openUserNavClass);
            window.setTimeout(function () {
                $userNav.removeClass(openingUserNavClass);
            }, openDuration);
        }
    });

    $(trigger).click(function () {

        if ($userNav.hasClass(openingUserNavClass)) {

            $(userInfoClass).removeClass(activeUserInfoClass);
            $userNav.removeClass(openUserNavClass);

            window.setTimeout(function () {
                $userNav.removeClass(openingUserNavClass);
            }, openDuration);

        } else {

            $(userInfoClass).addClass(activeUserInfoClass);
            $userNav.addClass(openingUserNavClass);

            window.setTimeout(function () {
                $userNav.addClass(openUserNavClass);
            }, openDuration);
        }
    });

}



// WEBPACK FOOTER //
// ./js/navbar/commons/NavbarUserMenu.js